import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getProjects: function ({
    limit = 999,
    page = 1,
    status,
    sort,
    client,
    dateStart,
    search,
    projectManager,
    supportManager,
    contactPm,
    projectType,
    parentProjectId,
    tags = [],
    estCompletion,
    estStartDate
  }) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (status) query.push(`status[]=${status}`)
    if (client) query.push(`client[]=${client}`)
    if (sort) query.push(`sort[]=${sort}`)
    if (search) query.push(`search=${search}`)
    if (dateStart) query.push(`dateStart=${dateStart}`)
    if (projectManager) query.push(`projectManager[]=${projectManager}`)
    if (supportManager) query.push(`supportManager[]=${supportManager}`)
    if (contactPm) query.push(`contactPm[]=${contactPm}`)
    if (parentProjectId) query.push(`parentProjectId[]=${parentProjectId}`)
    if (projectType) query.push(`projectType[]=${projectType}`)
    if (estCompletion) query.push(`estCompletion=${estCompletion}`)
    if (estStartDate) query.push(`estStartDate=${estStartDate}`)
    if (tags.length) query.push(...tags)
    const apiAddress = search ? 'projects' : 'projects/withoutelastic'
    return instCred.get(`${apiAddress}?${query.join('&')}`)
  },
  getProjectById: function (projectId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('projects/' + projectId)
  },
  getSubProjectsByParentId (projectId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('projects/getSubProjects/' + projectId)
  },
  getExcel: function (data) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('projects/excel', {data})
  },
  createProject: function (project) {
    project.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('projects', project)
  },
  editProject: function (project) {
    project.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('projects/' + project.id, project)
  },
  deleteProject: function (projectId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('projects/' + projectId)
  },
  copySteps: function (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('projects/copysteps', body)
  },
  completeProject: function (projectId, status = 0) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`projects/completed/${projectId}?status=${status}`)
  },
  getProjectsTotals: function ({status, client, dateStart}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = []
    if (status) query.push(`status[]=${status}`)
    if (client) query.push(`client[]=${client}`)
    if (dateStart) query.push(`dateStart=${dateStart}`)
    return instCred.get('projects/total?' + query.join('&'))
  },
  getUsersFilter ({isContact = true, isSupport = true, status}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = []
    if (isContact) query.push(`isContact=${isContact}`)
    if (isSupport) query.push(`isSupport=${isSupport}`)
    if (status) query.push(`status[]=${status}`)
    return instCred.get('projects/getUsersFilter?' + query.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Projects/api.js